import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IQualification, QualificationFormValue } from '../types';

import { qualificationSchema } from '../utils';

import { QUALIFICATIONS } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';

import { LoadingButton } from '@mui/lab';

import TextField from 'components/shared/ControlledFields/ControlledTextField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

interface Props {
  currentItem?: IQualification;
  handleClose: () => void;
}

const QualificationForm: React.FC<Props> = ({ currentItem, handleClose }) => {
  const { t } = useTranslation('common');
  const { mutateAsync: save, isLoading } = useSaveResource({
    url: QUALIFICATIONS,
    id: currentItem?.id,
    invalidateQueryKey: ['qualifications'],
    message: {
      error: t('adminPortal.errorDuringSave', { name: 'qualifications' })
    }
  });

  const methods = useForm<IQualification>({
    defaultValues: qualificationSchema(t).cast(currentItem),
    resolver: yupResolver(qualificationSchema(t)),
    mode: 'onChange'
  });

  const { control, handleSubmit } = methods;

  const onSubmit = (data: QualificationFormValue) => {
    save(data).then(handleClose);
  };

  return (
    <MultiStepForm methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <MultiStepForm.Section
        title={t('adminPortal.baseSelection')}
        validateFields={['code', 'name']}
      >
        <TextField
          name={'code'}
          control={control}
          variant={'outlined'}
          label={t('code')}
        />
        <TextField
          name={'name'}
          control={control}
          variant={'outlined'}
          label={t('name')}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Actions>
        <LoadingButton
          loading={isLoading}
          type="submit"
          variant="contained"
          autoFocus
          color="dark"
        >
          {t('save')}
        </LoadingButton>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};

export default QualificationForm;
